import { Box, Typography } from "@mui/material"
import type { FC } from ".."
import { Container, Grid } from ".."

type LeadInTextProps = {
  text: string
}

const LeadInText: FC<LeadInTextProps> = ({ text }) => {
  return (
    <Container>
      <Grid>
        <Box gridColumn={{ xs: "1 / -1", lg: "2 / -2", xl: "3 / -3" }}>
          <Typography
            component="h2"
            variant={"heading.2xl"}
            mb={{ xs: 12, md: 15 }}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </Box>
      </Grid>
    </Container>
  )
}

export default LeadInText
